export default Object.freeze({
  GAMETYPE: 'vleague'
});
